import { Search } from "@mui/icons-material";
import { colors, FormControl, InputLabel, MenuItem, OutlinedInput, Select, Tooltip } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { BiFile } from "react-icons/bi";
import moment from "moment";
import { H1 } from "../../../../../../components/UI/generalLayout/Layout.styled";
import CareLineDropdown from "../../../../../../components/dropdown/CareLineDropdown";
import Colors from "../../../../../../constants/Colors";
import { Name } from "./DetailsAttendanceRecord.styled";

export default function ProntuarioDrawer(props: any) {
    const [open, setOpen] = useState(false);
    const [anos, setAnos] = useState<any[]>([])
    const [atendimentos, setAtendimentos] = useState<any[]>([]);
    const [anoSelecionado, setAnoSelecionado] = useState<any>({});
    const [busca, setBusca] = useState("");
    const [evolucaoAberta, setEvolucaoAberta] = useState<number | null>(null);

    const abrirEvolucao = (index: number) =>
        setEvolucaoAberta(evolucaoAberta === index ? null : index);

    const atendimentosFiltrados = atendimentos.filter((a: any) =>
        a.profissional?.nome?.toLowerCase().includes(busca.toLowerCase())
    );

    const getAnos = useCallback(async () => {
        const service: any = new (await import("../../../../../../core/http/service/AppointmentService")).AppointmentService();
        const result: any = await service.getAnos();
        // setAnos(result.data.data);
        const anosFormatados = result.data.data.map((item: any) => ({
            id: item.ano,
            nome: item.ano
        }));

        setAnos(anosFormatados);

        if (result.data.data.length > 0) {
            const anoFormatado = {
                id: result.data.data[0].ano,
                nome: result.data.data[0].ano
            };

            setAnoSelecionado(anoFormatado)

        }
    }, []);

    useEffect(() => { getAnos(); }, []);

    const getResumo = useCallback(async (ano: string, pacienteId: string) => {
        setEvolucaoAberta(null);
        const service: any = new (await import("../../../../../../core/http/service/AppointmentService")).AppointmentService();
        const result: any = await service.getAtendimentoResumido(ano, pacienteId);
        setAtendimentos(result.data.data);
    }, []);

    return (
        <>
            {/* Floating Button */}
            {props.pacienteId && (
                <Tooltip title="Prontuário" arrow>
                    <button
                        className="fab"
                        onClick={() => {
                            getResumo(anoSelecionado.id, props.pacienteId);
                            setOpen(true);
                        }}
                    >
                        <BiFile size={26} />
                    </button>
                </Tooltip>
            )}

            {/* Drawer Overlay */}
            {open && (
                <nav className="drawer">
                    <div className="drawer-header">
                        <H1>Registro de Atendimentos</H1>
                        <button className="close-btn" onClick={() => setOpen(false)}>✕</button>
                    </div>

                    {/* Filtros */}
                    <div className="filters">
                        <OutlinedInput
                            value={busca}
                            onChange={(e) => {
                                setEvolucaoAberta(null);
                                setBusca(e.target.value);
                            }}
                            placeholder="Buscar nome do profissional"
                            startAdornment={<Search />}
                            style={{ width: '70%' }}
                            className="input-busca"
                        />

                        <div className="dropdown-wrapper">
                            <CareLineDropdown
                                value={anoSelecionado}
                                onChange={(item: any) => {

                                    const anoFormatado = {
                                        id: item.id,
                                        nome: item.nome
                                    };
                                    setAnoSelecionado(anoFormatado);
                                    getResumo(item.id, props.pacienteId);
                                }}
                                items={anos}
                                disabled={false}
                                backgroundColor={Colors.SPM50}
                                textColor={Colors.SPM600}
                                placeholder="Ano"
                                containerStyle={{
                                    width: "100%",
                                }}
                            />
                        </div>
                    </div>

                    {/* Tabela */}
                    <div className="table-container">
                        <div className="table-header">
                            <div>Data</div>
                            <div>Nome do profissional</div>
                            <div></div>
                        </div>
                        {atendimentosFiltrados.length > 0 ? (
                            atendimentosFiltrados.map((data, index) => (
                                <div key={index} className="attendance-card">
                                    <div>{moment(data.horario).format("DD/MM/YYYY")}</div>
                                    <div>{data.profissional?.nome}</div>
                                    <div>
                                        <button className="evolucao-btn" onClick={() => abrirEvolucao(index)}>
                                            EVOLUÇÃO ▾
                                        </button>
                                    </div>

                                    {evolucaoAberta === index && (
                                        <div className="evolucao-details">
                                            <h4>Subjetivo:</h4><p>{data.evolucaoSubjetivo}</p>
                                            <h4>Objetivo:</h4><p>{data.evolucaoObjetivo}</p>
                                            <h4>Avaliação:</h4><p>{data.evolucaoAvaliacao}</p>
                                            <h4>Plano:</h4><p>{data.evolucaoPlano}</p>
                                        </div>
                                    )}
                                </div>
                            ))
                        ) : (
                            <p>Nenhum resultado encontrado</p>
                        )}
                    </div>
                </nav>
            )}
        </>
    );
}